var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.active,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 80,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.active = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [_vm._v("Contacts")]),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column is-two-thirds" }, [
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Title")]),
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "select is-fullwidth" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contact.contact.title,
                          expression: "contact.contact.title",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.contact.contact,
                            "title",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "null", disabled: "" } }, [
                        _vm._v("Select"),
                      ]),
                      _vm._l(_vm.salutes, function (name, code) {
                        return _c(
                          "option",
                          { key: code, domProps: { value: name } },
                          [_vm._v(" " + _vm._s(name) + " ")]
                        )
                      }),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("First Name")]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contact.contact.firstName,
                      expression: "contact.contact.firstName",
                    },
                  ],
                  staticClass: "input",
                  class: {
                    "is-danger": _vm.$v.contact.contact.firstName.$error,
                  },
                  attrs: { type: "text" },
                  domProps: { value: _vm.contact.contact.firstName },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.contact.contact,
                          "firstName",
                          $event.target.value
                        )
                      },
                      function ($event) {
                        return _vm.$v.contact.contact.firstName.$touch()
                      },
                    ],
                  },
                }),
                !_vm.$v.contact.contact.firstName.required
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v("First Name is required"),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Last Name")]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contact.contact.lastName,
                      expression: "contact.contact.lastName",
                    },
                  ],
                  staticClass: "input",
                  class: {
                    "is-danger": _vm.$v.contact.contact.lastName.$error,
                  },
                  attrs: { type: "text" },
                  domProps: { value: _vm.contact.contact.lastName },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.contact.contact,
                          "lastName",
                          $event.target.value
                        )
                      },
                      function ($event) {
                        return _vm.$v.contact.contact.lastName.$touch()
                      },
                    ],
                  },
                }),
                !_vm.$v.contact.contact.lastName.required
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v("Last Name is required"),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("user-asset-addresses", {
                  ref: "addresses",
                  attrs: {
                    addresses: _vm.activeAddresses,
                    "country-code": _vm.sortedAddresses?.countryCode ?? null,
                    required: true,
                    "asset-type-name": "addresses",
                  },
                  on: {
                    removeAddress: _vm.removeAddress,
                    setDefault: _vm.setDefault,
                    addTmpAddress: _vm.addTmpAddress,
                    validationChanged: _vm.onRefsValidationChanged,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("user-asset-phones", {
                  ref: "phones",
                  attrs: {
                    phones: _vm.activePhones,
                    required: true,
                    "asset-type-name": "phones",
                  },
                  on: {
                    removePhone: _vm.removePhone,
                    setDefault: _vm.setDefault,
                    addTmpPhone: _vm.addTmpPhone,
                    validationChanged: _vm.onRefsValidationChanged,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("user-asset-emails", {
                  ref: "emails",
                  attrs: {
                    emails: _vm.activeEmails,
                    required: true,
                    "asset-type-name": "emails",
                  },
                  on: {
                    removeEmail: _vm.removeEmail,
                    setDefault: _vm.setDefault,
                    addTmpEmail: _vm.addTmpEmail,
                    validationChanged: _vm.onRefsValidationChanged,
                  },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Contents")]),
              _c("p", { staticClass: "control" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contact.contact.remarks.remarks,
                      expression: "contact.contact.remarks.remarks",
                    },
                  ],
                  staticClass: "textarea",
                  domProps: { value: _vm.contact.contact.remarks.remarks },
                  on: {
                    change: function ($event) {
                      _vm.contact.contact.isDirty = true
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.contact.contact.remarks,
                        "remarks",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("p", { staticClass: "control" }, [
                _c(
                  "a",
                  {
                    staticClass: "button is-primary",
                    on: { click: _vm.showRecurringRemark },
                  },
                  [
                    _c("span", { staticClass: "icon is-small" }, [
                      _c("i", { staticClass: "mdi mdi-repeat" }),
                    ]),
                    _c("span", [_vm._v(" Recurring Remarks")]),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Alert?")]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contact.contact.remarks.isAlert,
                      expression: "contact.contact.remarks.isAlert",
                    },
                  ],
                  staticClass: "switch is-rounded",
                  attrs: { id: "alert", name: "alert", type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.contact.contact.remarks.isAlert)
                      ? _vm._i(_vm.contact.contact.remarks.isAlert, null) > -1
                      : _vm.contact.contact.remarks.isAlert,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.contact.contact.remarks.isAlert,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.contact.contact.remarks,
                              "isAlert",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.contact.contact.remarks,
                              "isAlert",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.contact.contact.remarks, "isAlert", $$c)
                      }
                    },
                  },
                }),
                _c("label", { attrs: { for: "alert" } }),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot is-flex is-justify-content-flex-end" },
        [
          _c("div", { staticClass: "buttons" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary tooltip",
                attrs: {
                  "data-tooltip": "Save",
                  disabled: _vm.validationErrors,
                },
                on: { click: _vm.save },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("span", { staticClass: "mso mso-20px mso-fill" }, [
                    _vm._v(" save "),
                  ]),
                ]),
                _c("span", [_vm._v("Save")]),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "button tooltip",
                attrs: { "data-tooltip": "Cancel" },
                on: { click: _vm.close },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("span", { staticClass: "mso mso-20px" }, [
                    _vm._v(" close "),
                  ]),
                ]),
                _c("span", [_vm._v("Cancel")]),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }